module.exports = __webpack_public_path__ + "img/leg-left-side.050f6ff0.png";